export const expensTableSTyle = {
    container: {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      // background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
      // maxHeight: '100vh',
      padding: '20px'
    },
    expenseTableContainer: {
      maxWidth: '100%',
      margin: '0 auto'
    },
    expenseTableTitle: {
      color: '#ffffff',
      fontSize: '32px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '30px',
      textShadow: '0 2px 4px rgba(0,0,0,0.3)'
    },
    tableContainer: {
      background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
      borderBottomLeftRadius: '16px',
      borderBottomRightRadius: '16px',
      boxShadow: '0 20px 40px rgba(0,0,0,0.1), 0 0 20px rgba(30,60,114,0.2)',
      overflow: 'hidden',
      // height: '60vh',
      display: 'flex'
    },
    leftColumn: {
      width: '280px',
      flexShrink: 0,
      borderRight: '2px solid #e0e7ff',
      background: 'linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)',
      overflowY: 'auto'
    },
    rightColumn: {
      flex: 1,
      overflow: 'auto'
    },
    headerCell: {
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '16px',
      borderBottom: '2px solid #e0e7ff'
    },
    leftHeader: {
      position: 'sticky',
      top: 0,
      zIndex: 10
    },
    scrollableHeader: {
      display: 'flex',
      minWidth: 'max-content',
      position: 'sticky',
      top: 0,
      zIndex: 5
    },
    monthHeader: {
      minWidth: '140px',
      flexShrink: 0,
      borderRight: '1px solid #e2e8f0'
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      height: '50px',
      borderBottom: '1px solid #e2e8f0',
      fontSize: '14px',
      fontWeight: '500',
      color: '#374151',
      transition: 'all 0.3s ease'
    },
    leftCell: {
      padding: '0 16px',
      cursor: 'default'
    },
    expandableRow: {
      // background: 'linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 100%)',
      cursor: 'pointer',
      position: 'relative'
    },
    expandableRowHover: {
      // background: 'linear-gradient(90deg, #e2e8f0 0%, #cbd5e1 100%)',
      transform: 'translateX(2px)'
    },
    expandIcon: {
      position: 'absolute',
      right: '16px',
      width: '20px',
      height: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#667eea',
      fontSize: '18px',
      transition: 'transform 0.3s ease',
      
    },
    subRows: {
      // background: 'linear-gradient(180deg,rgb(254, 247, 255) 0%, rgba(38, 49, 69, 0.1) 100%)',
       background: 'linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 100%)',
     
      overflow: 'hidden',
      transition: 'max-height 0.3s ease',
      fontWeight:'900'
    },
    subCont:{
      boxShadow:"rgb(38, 49, 69) 0px 4px 4px -2px",
      // backgroundColor:""
      // margin:"15px 0px"
    },
    subRow: {
      height: '45px',
      display: 'flex',
      alignItems: 'center',
      padding: '0 32px',
      fontSize: '13px',
      color: '#004d49',
      borderBottom: '1px solid #e9d5ff'
    },
    scrollableContent: {
      display: 'flex',
      minWidth: 'max-content'
    },
    monthColumn: {
      minWidth: '140px',
      flexShrink: 0,
      borderRight: '1px solid #e2e8f0'
    },
    dataCell: {
      height: '50px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 8px',
      borderBottom: '1px solid #e2e8f0',
      fontSize: '13px',
      fontWeight: '500',
      color: '#374151'
    },
    dataCellNegative: {
      color: '#dc2626'
    },
    dataCellThirdParty: {
      // background: 'linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 100%)'
    },
    subDataCell: {
      height: '45px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 8px',
      borderBottom: '1px solid #e9d5ff',
      fontSize: '12px',
      color: '#004d49',
      fontWeight: '500'
    },
    subDataColumns: {
      // background: 'linear-gradient(180deg, #fef7ff 0%, #eee 100%)',
      background: 'linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 100%)',
      
      overflow: 'hidden',
      transition: 'max-height 0.3s ease',
      
    },
    totalRow: {
      height: '55px',
      display: 'flex',
      alignItems: 'center',
      padding: '0 16px',
      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      color: 'white',
      fontWeight: 'bold',
      fontSize: '15px',
      borderTop: '3px solid #34d399'
    },
    totalCell: {
      height: '55px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 8px',
      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      color: 'white',
      fontWeight: 'bold',
      fontSize: '14px',
      borderTop: '3px solid #34d399'
    },
    arrowDown: {
      width: 0,
      height: 0,
      borderLeft: '6px solid transparent',
      borderRight: '6px solid transparent',
      borderTop: '8px solid currentColor'
    },
    arrowUp: {
      width: 0,
      height: 0,
      borderLeft: '6px solid transparent',
      borderRight: '6px solid transparent',
      borderBottom: '8px solid currentColor'
    }
}